import { Box, Paper, Button } from "@material-ui/core";
import GenericPageTitle from "modus/components/generic-page-title/GenericPageTitle";
import { IEvent } from "pages/home/subscriptions/pages/subscription-summary-page/SubscriptionSummaryPage";
import React, {useEffect, useState} from "react";
import { EventList } from "../components/EventList";
import { ErrorMessage } from "modus/components/error-message/ErrorMessage";
import EventConfiguration from "../components/EventConfiguration";
import UpdateEventConfiguration from "../components/UpdateEventConfiguration"
import { TrimbleColors } from "legacy-components/TrimbleColors";
import { IService } from "pages/home/subscriptions/pages/subscription-summary-page/SubscriptionSummaryPage";
import EventService from "../service/EventService";
import { useIdentityEnvironmentFilter } from "pages/home/subscriptions/components/identity-environment-filter/IdentityEnvironmentFilter";

interface EventDiscoveryPageProps {
    eventDeployments?: IEvent[];
    subscriptionId: string;
    applicationId: string|undefined;
    serviceConfig: Array<IService> | undefined;
    onChange: () => void;
}

export const EventDiscoveryPage: React.FC<EventDiscoveryPageProps> = ({ eventDeployments, subscriptionId, applicationId, serviceConfig, onChange }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openUpdateEvent, setOpenUpdateEvent] = useState(false);

  const [currentEvent, setCurrentEvent] = useState<any>(undefined);
  const { filterEventEnvironmentList} = useIdentityEnvironmentFilter();
  const serviceConfigDeployments: { [key: string]: string[] } = {};
  const eventConfigDeployments: { [key: string]: string[] } = {};
  const displayConfigDeployments: { [key: string]: string[] } = {};

  // Region maps: { [version]: { [environment]: string[] } }
  const serviceRegionMap: { [version: string]: { [environment: string]: string[] } } = {};
  const subscribedRegionMap: { [version: string]: { [environment: string]: string[] } } = {};
  const regionMap: { [version: string]: { [environment: string]: { available: string[], subscribed: string[] } } } = {};

  useEffect(() => {
    if (!subscriptionId || currentEvent === undefined)
    {
      return;
    }
  }, [subscriptionId, currentEvent])


  serviceConfig?.forEach(service => {

    service.serviceVersions.forEach(serviceVersion => {

      if (serviceVersion.eventId !== ''){
        serviceConfigDeployments[serviceVersion.versionName] = [];

        serviceVersion.eventDeployments.forEach(deployment => {
          if(!serviceConfigDeployments[serviceVersion?.versionName].includes(deployment.environment))
            serviceConfigDeployments[serviceVersion?.versionName].push(deployment.environment);

          // Collect region info if present
          if (deployment.region !== undefined) {
            if (!serviceRegionMap[serviceVersion.versionName])
              serviceRegionMap[serviceVersion.versionName] = {};
            if (!serviceRegionMap[serviceVersion.versionName][deployment.environment])
              serviceRegionMap[serviceVersion.versionName][deployment.environment] = [];
            if (!serviceRegionMap[serviceVersion.versionName][deployment.environment].includes(deployment.region))
              serviceRegionMap[serviceVersion.versionName][deployment.environment].push(deployment.region);
          }
        })
      }
    })
});

      eventDeployments?.forEach(deployment => {
        const normalizedEnv = deployment.serviceDeployment === 'prd' ? 'production' : deployment.serviceDeployment === 'stg' ? 'stage' : deployment.serviceDeployment;

        if (!eventConfigDeployments[deployment.serviceVersion])
          eventConfigDeployments[deployment.serviceVersion] = [];
        if (!eventConfigDeployments[deployment.serviceVersion].includes(normalizedEnv))
          eventConfigDeployments[deployment.serviceVersion].push(normalizedEnv);

        // Collect subscribed region info if present
        if (deployment.region !== undefined) {
          if (!subscribedRegionMap[deployment.serviceVersion])
            subscribedRegionMap[deployment.serviceVersion] = {};
          if (!subscribedRegionMap[deployment.serviceVersion][normalizedEnv])
            subscribedRegionMap[deployment.serviceVersion][normalizedEnv] = [];
          if (!subscribedRegionMap[deployment.serviceVersion][normalizedEnv].includes(deployment.region))
            subscribedRegionMap[deployment.serviceVersion][normalizedEnv].push(deployment.region);
        }
      })

      for( const key in serviceConfigDeployments) {

        if (eventConfigDeployments[key] !== undefined){
        var difference: string[] = [];
        difference = serviceConfigDeployments[key].filter(env => {
          // If region data exists for this (version, env), only exclude if ALL regions are subscribed
          const availableRegions = serviceRegionMap[key]?.[env];
          if (availableRegions && availableRegions.length > 0) {
            const subscribedRegions = subscribedRegionMap[key]?.[env] ?? [];
            return availableRegions.some(r => !subscribedRegions.includes(r));
          }
          // No region data: use original logic — exclude if already subscribed
          return !eventConfigDeployments[key].includes(env);
        });
        difference = filterEventEnvironmentList(difference);

        if (difference.length !== 0)
        displayConfigDeployments[key]=difference;
        }
        else {
          displayConfigDeployments[key] = filterEventEnvironmentList(serviceConfigDeployments[key]);
        }
      }

      // Build regionMap for EventConfiguration
      for (const version in serviceRegionMap) {
        regionMap[version] = {};
        for (const env in serviceRegionMap[version]) {
          const allRegions = serviceRegionMap[version][env];
          const subscribed = subscribedRegionMap[version]?.[env] ?? [];
          const available = allRegions.filter(r => !subscribed.includes(r));
          regionMap[version][env] = {
            available: [...available].sort((a, b) => b.localeCompare(a)),
            subscribed: [...subscribed].sort((a, b) => b.localeCompare(a)),
          };
        }
      }

  const isEmpty = Object.keys(displayConfigDeployments).length === 0;

  const handleDrawerOpen = () => {
      setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
      setDrawerOpen(false);
      setOpenUpdateEvent(false)
  };

  const handleEditClick = (event: any) => {
    setCurrentEvent(event);
    setOpenUpdateEvent(true);
};

  const handleDeleteClick = async(event: any) => {
    setCurrentEvent(event);
    try {
      await EventService.deleteEventSubscription( subscriptionId, event.subscriptionTrn);
      onChange();
  } catch (error) {
      console.error("Error creating subscription:", error);
  }
};

  if(eventDeployments?.length===0 && isEmpty) {
    return <Box/>;
  }
  
  return (
  <Paper style={{padding: "30px", marginTop: "30px"}}>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
    <GenericPageTitle
        noSkeleton
        subTitle={<Box style={{fontSize:'20px'}}>Event Configuration</Box>}
        description={<Box style={{fontSize:'15px'}}>Customize event details to your preferences here by creating new Channels.</Box>}
    />
   
      <Button variant="contained" size="medium" style={{ backgroundColor: isEmpty ? TrimbleColors.Gray9: TrimbleColors.BlueDark, color: '#FFFFFF', marginTop: '10px'}} onClick={handleDrawerOpen}
      disabled={isEmpty}>
                    {isEmpty ? <>No Configurations Available</> : <>Add New Event Configuration</>} 
      </Button>
      </Box>
      <Box display="flex" justifyContent="flex-end" mb={2}>
      <EventConfiguration onChange={onChange} open={drawerOpen} onClose={handleDrawerClose} serviceList={displayConfigDeployments} subscriptionId={subscriptionId} applicationId={applicationId} regionMap={regionMap} />
      <UpdateEventConfiguration onChange={onChange} open={openUpdateEvent} onClose={handleDrawerClose} event_details={currentEvent} subscriptionId={subscriptionId} />
    </Box>
    {eventDeployments?.length!==0 && <EventList eventDeployments={eventDeployments} onEditClick={handleEditClick} onChange={onChange} subscriptionId={subscriptionId} />}
    {eventDeployments?.length===0 && <ErrorMessage message={"No Event configuration Initialized yet"}/>}
  </Paper>);
};
